// extracted by mini-css-extract-plugin
module.exports = {"root":"QuoteText_root__T3Mr0","withoutBackground":"QuoteText_withoutBackground__ebDZT","hasMaxWidth":"QuoteText_hasMaxWidth__I_qtP"};